import { translations } from './constants';

export const convertToFlatJson = (localizeTranslations: { [key: string]: { text: string } }): translations => {
  const result: { [key: string]: string } = {};
  Object.entries(localizeTranslations).forEach(([key, value]) => {
    result[key] = value.text;
  });
  return result;
};

export const convertToNestedJson = (localizeTranslations: { [key: string]: { text: string } }): translations => {
  const result: translations = {};

  for (const objectPath in localizeTranslations) {
    const parts = objectPath.split('.');

    let target = result;
    while (parts.length > 1) {
      const part = parts.shift() as string;
      target = target[part] = (target[part] as translations) || {};
    }

    target[parts[0]] = localizeTranslations[objectPath].text;
  }

  return result;
};

const cloneTranslations = (source: translations): translations =>
  Object.fromEntries(
    Object.entries(source).map(([key, value]) => [key, typeof value === 'string' ? value : cloneTranslations(value)]),
  );

export const nestShadowedFlatKeys = (source: translations): translations => {
  const result = cloneTranslations(source);

  Object.keys(result).forEach((key) => {
    const value = result[key];
    const path = key.split('.');
    if (typeof value !== 'string' || path.length < 2 || typeof result[path[0]] !== 'object') {
      return;
    }

    const parents = path.slice(0, -1);
    const leaf = path[path.length - 1];
    let existing: string | translations | undefined = result;
    for (const part of parents) {
      existing = (existing as translations)[part];
      if (existing === undefined) {
        break;
      }
      if (typeof existing === 'string') {
        return;
      }
    }
    if (existing !== undefined && (existing as translations)[leaf] !== undefined) {
      return;
    }

    let target = result;
    for (const part of parents) {
      target[part] = target[part] || {};
      target = target[part] as translations;
    }
    target[leaf] = value;
    delete result[key];
  });

  return result;
};
